export const infoRole = [
  {
    type: 'text',
    name: 'role',
    label: 'role',
    dataTestId: 'inputRole'
  }
];

export const oldLoginFields = [
  {
    type: 'text',
    name: 'pharmacistPin',
    label: 'userBoxPin',
    validation: 'required|length:6,6',
    dataTestId: 'inputPharmacistPin'
  },
  {
    label: 'farmacyEntryPin',
    type: 'text',
    name: 'pinCode',
    dataTestId: 'inputpinCode'
  }
];

export const newLoginFields = [
  {
    type: 'text',
    name: 'boxLoginPin',
    label: 'userBoxId',
    dataTestId: 'inputBoxLoginPin'
  },
  {
    type: 'text',
    name: 'newPinCode',
    label: 'pinCode',
    validation: 'required|length:6,6',
    dataTestId: 'inputNewPinCode'
  }
];
